import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

export default function Frontend() {
  return (
    <>
      <div id="frontEnd" className="min-vh-100 cs-bg-dark">
        <Header />
        <Outlet />
        <Footer />
      </div>
    </>
  );
}
